<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<style lang="scss">
#app {
  font-family: "Open Sans", -apple-system, system-ui, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #adb5bd;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #adb5bd;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>
import Navbar from "@/components/common/Navbar.vue";
import Footer from "@/components/common/Footer.vue";
import "./crisp";
import { AUTH_REFRESH } from "@/store/types";

export default {
  components: {
    Navbar,
    Footer
  },
  created() {
    this.$store.dispatch(AUTH_REFRESH);
  }
};
</script>
